import { types, Instance } from 'mobx-state-tree';

// The three pregnancy trimesters are a single user-facing category: the app only
// asks for the baby's due date and derives the trimester. So we surface them all
// as "Pregnancy" rather than the backend's per-trimester name (e.g. "Pregnancy – Trimester 2").
const PREGNANCY_TRIMESTER_UNIQUE_NAMES = [
  'PREGNANCY_TRIMESTER_1',
  'PREGNANCY_TRIMESTER_2',
  'PREGNANCY_TRIMESTER_3',
];

const ModificationModel = types
  .model('ModificationModel', {
    id: types.number,
    unique_name: types.string,
    name: types.string,
    workout_types: types.array(
      types.model({
        workout_template_type: types.string,
        fitness_level: types.string,
      }),
    ),
  })
  .views((self) => ({
    getAvailableFitnessLevelsForTemplateType(
      workoutTemplateType: string,
    ): string[] {
      return self.workout_types
        .filter((wt) => wt.workout_template_type === workoutTemplateType)
        .map((wt) => wt.fitness_level);
    },
    get displayName(): string {
      if (PREGNANCY_TRIMESTER_UNIQUE_NAMES.includes(self.unique_name)) {
        return 'Pregnancy';
      }
      return self.name;
    },
  }));

export type IModificationModel = Instance<typeof ModificationModel>;

export default ModificationModel;
